import { render, staticRenderFns } from "./FirstAccessPage.vue?vue&type=template&id=05ff3695&scoped=true&"
import script from "./FirstAccessPage.vue?vue&type=script&lang=js&"
export * from "./FirstAccessPage.vue?vue&type=script&lang=js&"
import style0 from "./FirstAccessPage.vue?vue&type=style&index=0&id=05ff3695&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05ff3695",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VLayout } from 'vuetify/lib/components/VGrid';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
installComponents(component, {VContainer,VLayout,VProgressCircular})
